import {
  CLIENT_PERFORMANCE,
  BACKEND_PERFORMANCE,
  EXPERIENCE_IMPACT,
  ECHART_BASE64_PREFIX,
} from '@src/icons/eco2/icon';

export const VERTICAL_HEIGHT_OF_NODE = 130;

export enum MetricCategoryTitle {
  Experience = 'Experience Impact',
  Client = 'Client Performance',
  Backend = 'Backend Performance',
}

export const ICON_MAP: Record<string, string> = {
  [MetricCategoryTitle.Experience]: ECHART_BASE64_PREFIX + EXPERIENCE_IMPACT,
  [MetricCategoryTitle.Client]: ECHART_BASE64_PREFIX + CLIENT_PERFORMANCE,
  [MetricCategoryTitle.Backend]: ECHART_BASE64_PREFIX + BACKEND_PERFORMANCE,
};

export const METRIC_CATEGORY_LIST = [
  {
    title: MetricCategoryTitle.Experience,
    icon: EXPERIENCE_IMPACT,
    context: 'session',
  },
  {
    title: MetricCategoryTitle.Client,
    icon: CLIENT_PERFORMANCE,
    context: 'event',
  },
  {
    title: MetricCategoryTitle.Backend,
    icon: BACKEND_PERFORMANCE,
    context: 'span',
  },
];

export const BASE_TEMPLATE: any = {
  tooltip: {
    show: false,
  },
  animationDurationUpdate: 1500,
  animationEasingUpdate: 'quinticInOut',
  series: [
    {
      type: 'graph',
      layout: 'none',
      symbolSize: 50,
      roam: false,
      draggable: false,
      label: {
        show: true,
        position: 'bottom',
        backgroundColor: '#f5f5f5',
        color: '#202020',
        padding: [6, 4],
        overflow: 'break',
      },
      edgeSymbol: ['none', 'arrow'],
      edgeSymbolSize: [0, 10],
      edgeLabel: {
        fontSize: 20,
        color: '#777777',
      },
      lineStyle: {
        opacity: 0.9,
        width: 2,
        curveness: 0,
      },
      data: [],
      links: [],
    },
  ],
};
